import { Injectable } from '@angular/core'
import { SmODataConfiguration } from '@exchange/services/core/odata'
import { IModelBase } from 'common-components'
import { HttpClient } from '@angular/common/http'
import { IEntityGroup } from './entityGroup'
import { ODataService } from 'common-services'

export interface IEntityGroupProvider extends IModelBase {
  EntityGroupId: number
  EntityGroup: IEntityGroup

  ProviderId: number
  ProviderKey: string
  ProviderName: string

  Npi: string
  TaxIdNumber: string
}

@Injectable()
export class EntityGroupProviderODataService extends ODataService<IEntityGroupProvider> {
  constructor(
    protected http: HttpClient,
    protected config: SmODataConfiguration
  ) {
    super(http, config)
    this.typeName = 'EntityGroupProviders'
  }
}
